import { render, staticRenderFns } from "./HeroesSidePicks.vue?vue&type=template&id=4a7017ef&"
import script from "./HeroesSidePicks.vue?vue&type=script&lang=js&"
export * from "./HeroesSidePicks.vue?vue&type=script&lang=js&"
import style0 from "./HeroesSidePicks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports